module.exports = __webpack_public_path__ + "da44e21ed3af7a1c063d352b95ca0c3e.png";